export var DAY_SIZE = 32;
export var DAY_MARGIN = 0;
export var DIALOG_WIDTH = 320;